import { QueryHookOptions, useQuery } from "@apollo/client";
import { WalletType } from "_graphql/mutation/__generated__/graphql";
import { GetSupplierWallets, GetSupplierWalletsVariables } from "_graphql/queries/__generated__/GetSupplierWallets";
import { GetTransactions, GetTransactionsVariables } from "_graphql/queries/__generated__/GetTransactions";
import { GetWalletPayouts, GetWalletPayoutsVariables } from "_graphql/queries/__generated__/GetWalletPayouts";
import { getPayoutTransactions, getSupplierWallets, getTransactions } from "_graphql/queries/wallet";
// import { getPayoutTransactions, getTransactions, getWallet, getWalletHistory, getWalletSummary } from "_graphql/queries/wallet";


// export const useWallet = (
//     options?: QueryHookOptions<Wallet, WalletVariables>
// ) => {
//     const { data, ...rest } = useQuery<Wallet, WalletVariables>(
//         getWallet,
//         options
//     );

//     return {
//         wallet: data?.wallet,
//         ...rest,
//     };
// }
// export const useWalletSummary = (
//     options?: QueryHookOptions<GetSupplierWalletSummary, GetSupplierWalletSummaryVariables>
// ) => {
//     const { data, ...rest } = useQuery<GetSupplierWalletSummary, GetSupplierWalletSummaryVariables>(
//         getWalletSummary,
//         options
//     );

//     return {
//         wallet: data?.getSupplierWalletSummary,
//         ...rest,
//     };
// }
export const usePayoutRequests = (
    options?: QueryHookOptions<GetWalletPayouts, GetWalletPayoutsVariables>
) => {
    const { data, ...rest } = useQuery<GetWalletPayouts, GetWalletPayoutsVariables>(
        getPayoutTransactions,
        options
    );

    return {
        payouts: data?.getWalletPayouts || [],
        count: 120,
        ...rest,
    };
}


// export const useWalletHistory = (
//     options?: QueryHookOptions<WalletHistory, WalletHistoryVariables>
// ) => {
//     const { data, ...rest } = useQuery<WalletHistory, WalletHistoryVariables>(
//         getWalletHistory,
//         options
//     );

//     return {
//         history: data?.walletHistory || [],
//         count: data?.walletHistoryLength || 0,
//         ...rest,
//     };
// }

export const useSupplierWallets = (variables?: GetSupplierWalletsVariables) => {
    const { data, ...rest } = useQuery<GetSupplierWallets, GetSupplierWalletsVariables>(getSupplierWallets, {
        variables
    })

    return {
        wallets: data?.getSupplierWallets || [],
        ...rest
    }
}

export const useWalletTransactions = (userId: string) => {
    const { data: walletData } = useQuery<GetSupplierWallets, GetSupplierWalletsVariables>(getSupplierWallets, {
        variables: {
            userId
        }
    })
    const walletId = walletData?.getSupplierWallets?.find((w) => !w?.currency.code.startsWith('p'))?.id ?? null;
    const { data, ...rest } = useQuery<GetTransactions, GetTransactionsVariables>(getTransactions, {
        variables: {
            input: {
                filter: {
                    wallet_type: {
                        eq: WalletType.Supplier
                    },
                    wallet_id: {
                        eq: walletId as string
                    }
                }
            }
        },
        skip: !walletData?.getSupplierWallets?.length

    })

    return {
        transactions: data?.getTransactions || [],
        ...rest
    }
}